import React from 'react'
import style from './getStarted.module.scss'
import button from '../../buttons.module.scss'


export default class GetStarted extends React.Component {

  // showModal = () => {
  //   const modal = document.getElementById('modal-sign-up');
  //   if (modal.className === 'show-modal') {
  //     modal.removeAttribute('class');
  //   } else {
  //     modal.className ='show-modal';
  //     document.body.className = 'modal-active';
  //   }
  //     return false;
  // }

  openSignUp = () => {
    return window.location.href = '/sign-up/';
  }

  render() {
    return (
      <div className={style.getStartedBottom}>
        <div>
          <img src={this.props.logo} width="auto" height="auto" alt='Duefocus' />
          <div>
            <span className={style.getStartedBottomTitle}>Get Started with DueFocus</span>
            {/* <p>Try DueFocus free for 14 days. No credit card required.</p> */}
            {/* <p>We are 100% Free Early Access </p> */}
          </div>
          <button onClick={this.openSignUp} className={button.buttonSignUp}>Start Free Trial</button>
        </div>
      </div>
    )
  }
}

